import { render } from "./RectangleStencil.vue?vue&type=template&id=7405d206"
import script from "./RectangleStencil.vue?vue&type=script&lang=js"
export * from "./RectangleStencil.vue?vue&type=script&lang=js"

import "./RectangleStencil.vue?vue&type=style&index=0&id=7405d206&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__